import { alpha, lighten, maxHeight, minHeight } from "@mui/system";

const styles = (theme) => ({
  containerComponent: {
    width: "100%",

    p: 2,
  },
  boxContainer: {
    borderRadius: 2,
    p: 3,
    mb: 2,
    textAlign: "center",
    transition: "0.2s",
    height: "350px",
    overflowY: "auto",
  },
  boxImagePreview: {
    position: "relative",
    borderRadius: 2,
    border: `1px solid ${alpha(theme.palette.text.primary, 0.3)}`,
    overflow: "hidden",
    textAlign: "center",
    p: 1,
  },
  avatar: {
    width: "100%",
    height: 100,
    objectFit: "cover",
    borderRadius: 2,
  },
  boxTitleAnexo: {
    maxWidth: "150px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    p: 1,
  },
  boxTextAnexo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "12px",
    margin: "0 10px",
  },
  containerCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    gap: 1,
  },
  textFileName: {
    wordBreak: "break-all",
    height: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconButton: {
    position: "absolute",
    top: 2,
    right: 2,
    zIndex: 2,
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: lighten(theme.palette.secondary.main, 0.2),
    },
  },
  textInfo: { mb: 1, fontSize: "14px" },
});

export default styles;
